import { validateTitle } from '@app/libs/validation';

export default function validateTemplateTitle(title: string) {
  return validateTitle(title, { maxLength: 100, minLength: 2, name: '템플릿 이름' });
}
